"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributesWithDrillDownDataLoaderFactory = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
var DataLoaderAbstractFactory_1 = require("./DataLoaderAbstractFactory");
var AttributesWithDrillDownDataLoader = /** @class */ (function () {
    function AttributesWithDrillDownDataLoader(workspace) {
        this.workspace = workspace;
    }
    AttributesWithDrillDownDataLoader.prototype.getAttributesWithDrillDown = function (backend) {
        var _this = this;
        if (!this.cachedAttributesWithDrillDown) {
            this.cachedAttributesWithDrillDown = backend
                .workspace(this.workspace)
                .catalog()
                .forTypes(["attribute", "dateDataset"])
                .load()
                .then(function (catalog) {
                var attributes = catalog.attributes();
                var dateAttributes = flatMap_1.default(catalog.dateDatasets(), function (dd) { return dd.dateAttributes; });
                return tslib_1.__spreadArrays(attributes, dateAttributes).filter(function (attr) { return attr.attribute.drillDownStep; });
            })
                .catch(function (error) {
                _this.cachedAttributesWithDrillDown = undefined;
                throw error;
            });
        }
        return this.cachedAttributesWithDrillDown;
    };
    return AttributesWithDrillDownDataLoader;
}());
/**
 * @internal
 */
exports.attributesWithDrillDownDataLoaderFactory = DataLoaderAbstractFactory_1.dataLoaderAbstractFactory(function (workspace) { return new AttributesWithDrillDownDataLoader(workspace); });
//# sourceMappingURL=AttributesWithDrillDownDataLoader.js.map